import { WEB_LINKS } from '@/shared/web/type';
import { useAuthUserStore } from '@/app/stores/user';
import { nativeApp } from '@/shared/services/native-app';

// @ts-ignore
export default async function isSignRight({ next }) {
  const authUserStore = useAuthUserStore();
  if (!authUserStore.user.id || !authUserStore.authorized) await authUserStore.getUser();
  if (authUserStore.isUserNotFound) return next();

  //TODO надо будет исправить, дублирование логики c auth
  if (!authUserStore.authorized) {
    return nativeApp.sessionExpired();
  }

  const isNone = authUserStore.isSignNone;
  if (!isNone) return next();

  return next({
    name: WEB_LINKS.INSTALLMENT,
  });
}
